import React from "react"

const Outils = () => {
  return <div className="outils" />
}

export default Outils
